/**
 * shadcn/ui Input — vendored + tokenized for CertAIn v2 (Phase 1 fan-out foundation).
 *
 * Stock shadcn input; `border-input`/`bg-background`/`ring` swapped for CertAIn
 * semantic utilities so it resolves inside `[data-theme="v2"]`. Reproduces the
 * canonical `.input` (design/v2-direction/index.html lines 378-384): 36px tall,
 * --radius, --input hairline, blue focus ring. Guard-clean.
 *
 * Used by the search toolbar and every v2 form field (JD new/edit, Candidate
 * new, Settings) — patterns/FormFieldV2 wraps it with a Label.
 */
import * as React from "react";
import { cn } from "@/lib/utils";

const Input = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, type, ...props }, ref) => (
  <input
    type={type}
    ref={ref}
    className={cn(
      "flex h-9 w-full rounded-[var(--radius,0.5rem)] border border-border-strong bg-surface-elevated px-3 py-1 text-[13.5px] text-text-primary shadow-sm transition-colors",
      "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-text-primary",
      "placeholder:text-text-tertiary",
      "focus-visible:outline-none focus-visible:border-border-focus focus-visible:ring-2 focus-visible:ring-border-focus/40",
      "disabled:cursor-not-allowed disabled:opacity-50",
      className,
    )}
    {...props}
  />
));
Input.displayName = "Input";

export { Input };
